import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import * as segmentio from 'rp-analytics';
import trimHyphen from '../../../AccountPage/helpers/trimHyphen';
import SubmitButton from '../../../common/SubmitButton';
import RequiredField from '../../../common/RequiredField';
import StepHeadding from '../StepHeadding';
import check from '../../../../helpers/check';

import { goToNextStepWhenLoginIsSkipped } from '../../../../actions/auth';
import { loadUserAmendRequest } from '../../../../actions/userInfo/index';

import styles from './personalDetails.scss';

const PERSONAL_DETAILS_FORM = 'personalDetails';

const defaultUserInfo = {
  firstName: '',
  phoneNumber: '',
  lastName: '',
};

class PersonalDetails extends Component {
    static propTypes = {
      handleSubmit: PropTypes.func.isRequired,
      fetching: PropTypes.bool.isRequired,
    };

    onSubmit = (values) => {
      const {
        loadUserAmendRequest,
        isLoginSkipped,
        goToNextStepWhenLoginIsSkipped,
        packageTitle,
      } = this.props;

      loadUserAmendRequest({
        firstName: values.firstName,
        lastName: values.lastName,
        phone: values.phone,
      });

      // TODO: extract this in shared library
      const localStorageBetslip = localStorage.getItem('persist:betslip');
      const parsedBetslipData = JSON.parse(localStorageBetslip);
      const parsedBookmakersInfo = JSON.parse(parsedBetslipData.bookmakersInfo);

      segmentio.trackSubscriptionSaleAttempt({
        location: 'Subscribe',
        subsection: null,
        package: packageTitle.replace('Annual', 'Yearly'),
        bet_slip_id: parsedBookmakersInfo.betslipID,
      });

      setTimeout(() => {
        if (isLoginSkipped) {
          goToNextStepWhenLoginIsSkipped();
        }
      }, 1000);
    };

    render() {
      const { handleSubmit, fetching } = this.props;
      return (
        <div className={styles.root}>
          <StepHeadding stepNumber="two" stepTitle="Personal details" />
          <form
            onSubmit={handleSubmit(this.onSubmit)}
            name={PERSONAL_DETAILS_FORM}
            className={styles.form}
                >
            <div className={styles.fieldSet}>
              <Field
                name="firstName"
                label="First Name"
                type="text"
                component={RequiredField}
                customProps={{ container: { className: styles.fieldContainer } }}
              />
              <Field
                name="lastName"
                label="Last Name"
                type="text"
                component={RequiredField}
                customProps={{ container: { className: styles.fieldContainer } }}
              />
              <Field
                name="phone"
                label="Phone Number"
                type="text"
                component={RequiredField}
                customProps={{ container: { className: styles.fieldContainer } }}
              />
            </div>
            <SubmitButton label="Next Step" loading={fetching} />
            <div
              className={`${styles.validation} ${this.props.submitFailed &&
                            'mc-form--invalid'} ${styles.mandatory}`}
                    >
                        mandatory field*
            </div>
          </form>
        </div>
      );
    }
}

function validate(values) {
  const errors = {};

  /* replace "smart" quotes with regular ones (since iOS 11.0 the default iOS keyboard uses "smart" quotes, which are different characters) */
  const firstName = values.firstName.replace(/[\u2018\u2019]/g, "'");
  const lastName = values.lastName.replace(/[\u2018\u2019]/g, "'");

  errors.firstName = check(firstName)
    .required()
    .withMessage('Please confirm your First name')
    .pattern(/^[a-z'\- ]+$/i)
    .withMessage('Valid characters are letters, spaces, hyphens and single quotations')
    .validate();

  errors.lastName = check(lastName)
    .required()
    .withMessage('Please confirm your Last name')
    .pattern(/^[a-z'\- ]+$/i)
    .withMessage('Valid characters are letters, spaces, hyphens and single quotations')
    .validate();

  errors.phone = check(values.phone)
    .required()
    .withMessage('Please confirm your Phone number')
    .pattern(/^[0-9]+$/i)
    .withMessage('Valid Phone number contains only digits')
    .validate();

  return errors;
}

export default compose(
  connect(
    (state) => {
      const userInfo = Object.assign({}, defaultUserInfo, state.userInfo.data);
      return {
        initialValues: {
          firstName: trimHyphen(userInfo.firstName),
          lastName: trimHyphen(userInfo.lastName),
          phone: userInfo.phoneNumber || '',
        },
        fetching: state.userInfo.fetching,
        isLoginSkipped: state.auth.isLoginSkipped,
      };
    },
    { loadUserAmendRequest, goToNextStepWhenLoginIsSkipped },
  ),
  reduxForm({
    form: PERSONAL_DETAILS_FORM,
    validate,
  }),
)(PersonalDetails);
